import { useCtaasServiceStatus } from './useCtaasServiceStatus';
import { useIsEligibleForFreeCtaas } from './useIsEligibleForFreeCtaas';
import { ServiceStatus } from '../types';

const disabledOptions = {
  disabled: false,
  disabledTooltip: '',
};

export const useTrainingAccess = () => {
  const ctaasServiceStatus = useCtaasServiceStatus();
  const isEligibleForFreeCtaas = useIsEligibleForFreeCtaas();

  if (
    [ServiceStatus.ActivationInProgress, ServiceStatus.Activated].includes(
      ctaasServiceStatus
    )
  ) {
    return disabledOptions;
  }

  if (
    ServiceStatus.RequestReceived === ctaasServiceStatus &&
    isEligibleForFreeCtaas
  ) {
    return disabledOptions;
  }

  return {
    disabled: true,
    disabledTooltip:
      'Activate your cybersecurity training service via the Resiliency Services catalog',
  };
};
